import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import ScrollReveal from "../components/ScrollReveal";
import CTASection from "../components/sections/CTASection";
import { BLOG_POSTS } from "../data/content";

export default function BlogPage() {
  const [featured, ...rest] = BLOG_POSTS;

  return (
    <div data-testid="blog-page">
      <section className="pt-36 md:pt-44 pb-16 md:pb-20 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-4">
              / Blog
            </div>
            <h1 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.95]">
              Obsidian<br /><span className="text-white/40">dispatches.</span>
            </h1>
            <p className="mt-6 text-white/60 max-w-2xl text-base md:text-lg leading-relaxed">
              Sharp thinking on design, conversion, brand systems and how we
              ship at speed. No fluff — just what moves numbers.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Featured post */}
      <section className="py-16 md:py-24 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <ScrollReveal>
            <Link
              to={`/blog/${featured.slug}`}
              data-testid={`blog-featured-${featured.slug}`}
              className="group grid lg:grid-cols-2 gap-8 lg:gap-14 items-center"
            >
              <div className="relative aspect-[4/3] overflow-hidden border border-white/10">
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute top-5 left-5 text-[10px] uppercase tracking-[0.3em] bg-black/60 backdrop-blur px-3 py-1.5 border border-white/10">
                  Featured
                </div>
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">
                  {featured.date} · {featured.readTime}
                </div>
                <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight leading-[1] group-hover:text-white/70 transition-colors">
                  {featured.title}
                </h2>
                <p className="mt-5 text-white/60 leading-relaxed">
                  {featured.excerpt}
                </p>
                <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-white group-hover:gap-4 transition-all">
                  Read Article <ArrowUpRight size={14} />
                </div>
              </div>
            </Link>
          </ScrollReveal>
        </div>
      </section>

      {/* Rest of posts */}
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-8">
            {rest.map((p, i) => (
              <ScrollReveal key={p.slug} delay={i * 0.05}>
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-card-${p.slug}`}
                  className="group block border border-white/10 bg-[#080808] hover:border-white/30 transition-colors"
                >
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={p.image}
                      alt={p.title}
                      className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-6 md:p-8">
                    <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-3">
                      {p.date} · {p.readTime}
                    </div>
                    <h3 className="font-display text-xl md:text-2xl font-extrabold uppercase tracking-tight leading-[1.1] group-hover:text-white/70 transition-colors">
                      {p.title}
                    </h3>
                    <p className="mt-4 text-white/55 text-sm leading-relaxed">
                      {p.excerpt}
                    </p>
                  </div>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
